import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type RecaptchaState = {
  submitToken: string
}

const initialState: RecaptchaState = {
  submitToken: '',
}

const slice = createSlice({
  name: 'recaptcha',
  initialState,
  reducers: {
    setSubmitToken: (
      state,
      { payload: submitToken }: PayloadAction<string>,
    ) => {
      state.submitToken = submitToken
    },
  },
})

export const { setSubmitToken } = slice.actions

export const recaptchaReducer = slice.reducer
